import React from 'react';

const pulseKeyframes = `
@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }
@keyframes flipHourglass { 0%, 45% { transform: rotate(0deg); } 50%, 95% { transform: rotate(180deg); } 100% { transform: rotate(360deg); } }
`;

export default function MaintenancePage() {
  return (
    <div style={{
      minHeight: '100vh', background: '#0a0a0a', display: 'flex',
      flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '40px 20px', fontFamily: "'DM Sans', sans-serif", color: '#fff',
    }}>
      <style>{pulseKeyframes}</style>

      {/* Logo */}
      <div style={{ marginBottom: 24, display: 'flex', alignItems: 'baseline', justifyContent: 'center', gap: 6 }}>
        <span style={{ fontFamily: "'Dela Gothic One', serif", fontSize: 26, color: '#00e676', lineHeight: 1 }}>$</span>
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
            <span style={{ fontFamily: "'Dela Gothic One', serif", fontSize: 20, color: '#ffffff', letterSpacing: 1 }}>PayDirt</span>
            <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 9, color: '#00e676', fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase' }}>News</span>
          </div>
          <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 7, color: '#444', letterSpacing: 2, textTransform: 'uppercase' }}>Where Truth is Measured</span>
        </div>
      </div>

      {/* Image */}
      <img
        src="/maintenance.jpeg"
        alt="Maintenance"
        style={{ maxWidth: 300, width: '100%', borderRadius: 12, opacity: 0.9, marginBottom: 24 }}
      />

      {/* Status indicator */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
        <span style={{
          width: 8, height: 8, borderRadius: '50%', background: '#00e676',
          display: 'inline-block', animation: 'pulse 1.5s infinite',
        }} />
        <span style={{ fontSize: 11, fontFamily: "'IBM Plex Mono', monospace", color: '#00e676', letterSpacing: '0.15em', textTransform: 'uppercase' }}>
          Actively Working
        </span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00e676" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          style={{ animation: 'flipHourglass 3s ease-in-out infinite' }}>
          <path d="M5 22h14" /><path d="M5 2h14" />
          <path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22" />
          <path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2" />
        </svg>
      </div>

      {/* Message card */}
      <div style={{
        background: '#111', border: '1px solid #1a1a1a', borderRadius: 16,
        padding: '28px 24px', maxWidth: 520, width: '100%', lineHeight: 1.7,
        fontSize: 14, color: '#b0b0b0', textAlign: 'center',
      }}>
        <p style={{ margin: '0 0 16px' }}>
          We're not sure if market forces are the answer, but we're trying to use them to find a better proximity for the truth. Somehow over the years, objectivity, honesty, and the veracity of facts have become lost in the simulacra.
        </p>
        <p style={{ margin: '0 0 16px' }}>
          Our overall goal is to help encourage people to read critically, to use logic and reason, to question themselves and others — and to put a value on real and honest communication.
        </p>
        <p style={{ margin: '0 0 16px', color: '#00e676', fontWeight: 500 }}>
          No BS, no manipulation, no bias.
        </p>
        <p style={{ margin: 0 }}>
          That's why we're helping you get paid on dirt. We're not going to be perfect and we need your help, so while we're in our basements and dusty university libraries trying to get to the bottom of the truth, we thank you for your patience.
        </p>
      </div>

      {/* Footer */}
      <div style={{ marginTop: 32, fontSize: 10, fontFamily: "'IBM Plex Mono', monospace", color: '#444', letterSpacing: '0.1em' }}>
        paydirtnews.com
      </div>
    </div>
  );
}
